import { ListingActionTypes } from '@state/features/common.types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@stone/ui/button/Button';
import classNames from 'classnames';
const Breadcrumbs = (props) => {
    var _a, _b, _c, _d, _e;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { breadcrumbs, shelf } = useSelector((state) => state.search);
    const shelfKeys = Object.keys(shelf);
    let breadcrumbsList;
    if ((_b = (_a = props.product) === null || _a === void 0 ? void 0 : _a.breadcrumbs) === null || _b === void 0 ? void 0 : _b.length) {
        breadcrumbsList = [...props.product.breadcrumbs];
    }
    else if (props.cgid && shelfKeys.length && shelfKeys.includes(props.cgid)) {
        breadcrumbsList = [...(_c = shelf[props.cgid]) === null || _c === void 0 ? void 0 : _c.breadcrumbs];
    }
    else {
        breadcrumbsList = breadcrumbs ? [...breadcrumbs] : [];
    }
    if ((breadcrumbsList === null || breadcrumbsList === void 0 ? void 0 : breadcrumbsList.length) <= 1) {
        return React.createElement("div", null);
    }
    else {
        const currentPage = breadcrumbsList.pop();
        const baseUrl = location.origin;
        const currentPageUrl = `${baseUrl}${currentPage.url}`;
        return (React.createElement(React.Fragment, null,
            React.createElement("nav", { "aria-label": t('navigation.breadcrumb.aria'), className: "breadcrumb" },
                React.createElement("ol", null,
                    breadcrumbsList.map((item, i) => (React.createElement("li", { key: i },
                        React.createElement("a", { href: `${baseUrl}${item.url}`, onClick: () => {
                                dispatch({
                                    type: ListingActionTypes.FETCH_LISTING,
                                    payload: {
                                        cgid: item.categoryId,
                                        resultsType: 'INIT',
                                        start: 0,
                                    },
                                });
                            }, className: "breadcrumb__item", key: item.categoryId }, item.htmlValue)))),
                    React.createElement("li", null, ((_e = (_d = props.product) === null || _d === void 0 ? void 0 : _d.breadcrumbs) === null || _e === void 0 ? void 0 : _e.length) ? (React.createElement("a", { href: currentPageUrl, onClick: () => {
                            dispatch({
                                type: ListingActionTypes.FETCH_LISTING,
                                payload: {
                                    cgid: currentPage.categoryId,
                                    resultsType: 'INIT',
                                    start: 0,
                                },
                            });
                        }, className: "breadcrumb__item", key: currentPage.categoryId }, currentPage.htmlValue)) : (React.createElement("div", { "aria-current": "page", className: "breadcrumb__item", key: currentPage.categoryId }, currentPage.htmlValue)))))));
    }
};
const Back = (props) => {
    var _a, _b, _c;
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { breadcrumbs, shelf } = useSelector((state) => state.search);
    const shelfKeys = Object.keys(shelf);
    let breadcrumbsList;
    if ((_b = (_a = props.product) === null || _a === void 0 ? void 0 : _a.breadcrumbs) === null || _b === void 0 ? void 0 : _b.length) {
        breadcrumbsList = [...props.product.breadcrumbs];
    }
    else if (props.cgid && shelfKeys.length && shelfKeys.includes(props.cgid)) {
        breadcrumbsList = [...(_c = shelf[props.cgid]) === null || _c === void 0 ? void 0 : _c.breadcrumbs];
    }
    else {
        breadcrumbsList = breadcrumbs ? [...breadcrumbs] : [];
    }
    const baseUrl = location.origin;
    //remove current page
    breadcrumbsList.pop();
    let backpage = breadcrumbsList.pop();
    if (!backpage)
        return (React.createElement("a", { className: props.className, href: window.homeurl },
            React.createElement("span", null, "<"),
            " ",
            React.createElement("span", null, props.staticLabel || t('label.sitename'))));
    return props.cgid ? (React.createElement(Button, { type: "button", inverted: props.inverted, cls: [], ariaLabel: props.staticLabel || backpage.htmlValue, onClick: () => {
            dispatch({
                type: ListingActionTypes.FETCH_LISTING,
                payload: {
                    cgid: backpage.categoryId,
                    resultsType: 'INIT',
                    start: 0,
                    isShelf: false,
                },
            });
        }, className: props.className },
        React.createElement(React.Fragment, null,
            "< ",
            props.staticLabel || backpage.htmlValue))) : (React.createElement("a", { className: classNames(props.className, { inverted: props.inverted }), href: baseUrl + backpage.url },
        React.createElement("span", null, "<"),
        " ",
        React.createElement("span", null, props.staticLabel || backpage.htmlValue)));
};
export { Back };
export default Breadcrumbs;
